/**
 * @tabler/icons-solidjs v2.32.0 - MIT
 */

import createSolidComponent from '../createSolidComponent.js';

var IconBadgesFilled = createSolidComponent("badges-filled", "IconBadgesFilled", [
  [
    "path",
    {
      d: "M16.486 12.143l-4.486 2.69l-4.486 -2.69a1 1 0 0 0 -1.514 .857v4a1 1 0 0 0 .486 .857l5 3a1 1 0 0 0 1.028 0l5 -3a1 1 0 0 0 .486 -.857v-4a1 1 0 0 0 -1.514 -.857z",
      "stroke-width": "0",
      fill: "currentColor"
    }
  ],
  [
    "path",
    {
      d: "M16.486 3.143l-4.486 2.69l-4.486 -2.69a1 1 0 0 0 -1.514 .857v4a1 1 0 0 0 .486 .857l5 3a1 1 0 0 0 1.028 0l5 -3a1 1 0 0 0 .486 -.857v-4a1 1 0 0 0 -1.514 -.857z",
      "stroke-width": "0",
      fill: "currentColor"
    }
  ]
]);

export { IconBadgesFilled as default };
//# sourceMappingURL=IconBadgesFilled.js.map
